import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEnvatoComponent } from './simple-icons-envato.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEnvatoComponent ],
    exports:      [ SimpleIconsEnvatoComponent ],
    bootstrap:    []
})
export class SimpleIconsEnvatoModule {}
